import React from 'react';
import classes from './Section4.module.css';
import pic1 from '../../../Images/education.png';
import pic2 from '../../../Images/address.png';
import pic3 from '../../../Images/email.png';
import pic4 from '../../../Images/instagram.png';
import pic5 from '../../../Images/linkedIn.png';
import pic6 from '../../../Images/github.png';
import pic7 from '../../../Images/Youtube.png';
import {Container,Row,Col,Button} from 'react-bootstrap';

const section4=()=>{
    return(
        <div className={classes.Section4}>
           <div className={classes.heading}>
                <h4>Bio Data</h4>  
            </div>
           <div className={classes.Details1}>
                <Container>
                    <Row>
                        <Col>
                            <a href="http://www.cbit.edu.in/" alt="" target="_blank" rel="noreferrer"><img className={classes.img1} src={pic1} alt="" /></a>
                            <p>Education</p> 
                        </Col>
                        <Col>
                            <a href="https://www.google.co.in/maps/place/14%C2%B020'52.1%22N+79%C2%B013'45.6%22E/@14.3480418,79.2265,17z/data=!4m13!1m6!3m5!1s0x3bb33716ac50485f:0xf65160b0d69404cb!2sNikhil+Shop!8m2!3d14.3480366!4d79.2286887!3m5!1s0x3bb33716b6c09cd3:0x7716b6663e2cc389!7e2!8m2!3d14.3478049!4d79.2293289" alt="" target="_blank" rel="noreferrer"><img className={classes.img1} src={pic2} alt="" /></a>
                            <p>Address</p> 
                        </Col>
                    </Row>
                </Container>
           </div>
           <div className={classes.Details2}>
                <Container>
                    <Row>
                        <Col>
                            <a href="mailto:karanamnikhil00@gmail.com" alt="" target="_blank" rel="noreferrer"><img className={classes.img2} src={pic3} alt="" /></a>
                            
                        </Col>
                        <Col>
                            <a href="https://www.instagram.com/nikhil_karanam_official/" alt="" target="_blank" rel="noreferrer"><img className={classes.img2} src={pic4} alt="" /></a>
                            
                        </Col>
                        <Col>
                            <a href="https://www.linkedin.com/in/nikhil-karanam-98492218b/" alt="" target="_blank" rel="noreferrer"><img className={classes.img2} src={pic5} alt="" /></a>
                            
                        </Col>
                        <Col>
                            <a href="https://github.com/Nikhil14311" alt="" target="_blank" rel="noreferrer"><img className={classes.img2} src={pic6} alt="" /></a>
                            
                        </Col>
                        <Col>
                            <a href="https://www.youtube.com/channel/UC1pYeJSOv4AP3XrrIJN5M5w" alt="" target="_blank" rel="noreferrer"><img className={classes.img2} src={pic7} alt="" /></a>
                            
                        </Col>
                    </Row>
                </Container>
           </div>
           
        </div>
    )
}

export default section4;
